import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "closee" ]

  close(e) {
    this.closeeTargets.forEach((el) => {
      el.style.display = "none";
    })
  }

}
